import { Leaf, Sprout } from "lucide-react";
import { IMAGES } from "@/constants";

export const AboutSection = () => {
    return (
        <section id="about" data-testid="about-section" className="py-16 sm:py-24">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
                    <div>
                        <h2
                            data-testid="about-heading"
                            className="font-heading font-semibold tracking-tight text-primary text-2xl sm:text-3xl lg:text-4xl"
                        >
                            About Dirt Cheapest Sod Corp
                        </h2>
                        <p className="mt-6 text-base text-muted-foreground leading-relaxed">
                            Dirt Cheapest Sod Corp is a sod and ornamental nursery business
                            located in Boynton Beach, Florida. The company operates in the
                            sod and ornamental nursery industry, serving the local South
                            Florida region.
                        </p>
                        <div className="mt-10 grid sm:grid-cols-2 gap-6">
                            <div
                                data-testid="about-sod-card"
                                className="rounded-lg border border-border bg-card p-6 shadow-sm"
                            >
                                <Leaf className="h-6 w-6 text-primary" aria-hidden="true" />
                                <h3 className="mt-4 font-heading font-semibold text-lg">Sod</h3>
                                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                                    Turfgrass sod for lawns and landscaping projects.
                                </p>
                            </div>
                            <div
                                data-testid="about-nursery-card"
                                className="rounded-lg border border-border bg-card p-6 shadow-sm"
                            >
                                <Sprout className="h-6 w-6 text-primary" aria-hidden="true" />
                                <h3 className="mt-4 font-heading font-semibold text-lg">
                                    Ornamental Nursery
                                </h3>
                                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                                    Ornamental plants for residential and commercial landscapes.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-rows-2 gap-4">
                        <img
                            src={IMAGES.sod}
                            alt="Lush green grass field"
                            loading="lazy"
                            className="rounded-lg w-full h-56 sm:h-64 object-cover"
                        />
                        <img
                            src={IMAGES.nursery}
                            alt="Ornamental plants at a nursery"
                            loading="lazy"
                            className="rounded-lg w-full h-56 sm:h-64 object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
